import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import axios from "axios";
import { MyApi } from "../../MyApi";
import img1 from "../../assets/images/1.svg";
import img2 from "../../assets/images/2.svg";
import img3 from "../../assets/images/3.svg";
import img4 from "../../assets/images/4.svg";

export default function WhyTravel() {
  const [data, setData] = useState({
    trusted: null,
    transport: null,
    guiding: null,
    satisfaction: null,
  });

  // 🔹 Normalize CMS data (only what UI needs)
  const normalizeCms = (item) => ({
    title: item.pageheading || item.pagename,
    content: item.pagecontent,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = { Authorization: MyApi.SECRET_KEY };

        const [
          trustedRes,
          transportRes,
          guidingRes,
          satisfactionRes,
        ] = await Promise.all([
          axios.get(MyApi.BASE_URL + "trusted-tour-operator", { headers }),
          axios.get(MyApi.BASE_URL + "reliable-transport", { headers }),
          axios.get(MyApi.BASE_URL + "yearsof-guiding", { headers }),
          axios.get(MyApi.BASE_URL + "customer-satisfaction", { headers }),
        ]);

        setData({
          trusted: trustedRes.data?.status
            ? normalizeCms(trustedRes.data.data)
            : null,

          transport: transportRes.data?.status
            ? normalizeCms(transportRes.data.data)
            : null,

          guiding: guidingRes.data?.status
            ? normalizeCms(guidingRes.data.data)
            : null,

          satisfaction: satisfactionRes.data?.status
            ? normalizeCms(satisfactionRes.data.data)
            : null,
        });
      } catch (error) {
        console.error("WhyTravel API Error:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="why_t">
      <Container>
        <div className="heading_a">
          <span>Kashi Journeys Specials</span>
          <h3>Why Explore Varanasi with Us</h3>
        </div>

        <Row>
          {data.trusted && (
            <Col md="3" className="mb-4">
              <div className="whywinn h-100">
                <img src={img2} className="white-icon" alt="" />
                <h4 className="mt-5 mb-3">{data.trusted.title}</h4>
                <div dangerouslySetInnerHTML={{ __html: data.trusted.content }} />
              </div>
            </Col>
          )}

          {data.transport && (
            <Col md="3" className="mb-4">
              <div className="whywinn h-100">
                <img src={img1} className="white-icon" alt="" />
                <h4 className="mt-5 mb-3">{data.transport.title}</h4>
                <div
                  dangerouslySetInnerHTML={{ __html: data.transport.content }}
                />
              </div>
            </Col>
          )}

          {data.guiding && (
            <Col md="3" className="mb-4">
              <div className="whywinn h-100">
                <img src={img3} className="white-icon" alt="" />
                <h4 className="mt-5 mb-3">{data.guiding.title}</h4>
                <div
                  dangerouslySetInnerHTML={{ __html: data.guiding.content }}
                />
              </div>
            </Col>
          )}

          {data.satisfaction && (
            <Col md="3" className="mb-4">
              <div className="whywinn h-100">
                <img src={img4} className="white-icon" alt="" />
                <h4 className="mt-5 mb-3">{data.satisfaction.title}</h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.satisfaction.content,
                  }}
                />
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}
